import { connect } from "react-redux";
import Main from "./Main.jsx";

const mapStateToProps = ({

}) => ({

});

const mapDispatchToProps = () => dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./client/app/components/Main/MainContainer.js